module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      backgroundColor: _vm.color
    })
  }, [_c('div', {
    staticStyle: {
      "padding-top": "2px",
      "padding-bottom": "200px"
    }
  }, [_c('span', {
    staticClass: "not-found",
    staticStyle: {
      "display": "table",
      "width": "100%",
      "color": "#3498db",
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "row justify-content-md-center justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-3 col-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.staticImg + 'notfound.png',
      "alt": "404 Not Found"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "headerTwo"
  }, [_vm._v("We can't seem to find the page you are looking for")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg btn-block mb15 pointer text-uppercase center",
    on: {
      "click": _vm.home
    }
  }, [_vm._v("Let's take you home")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b49821b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/NoProductsFound.vue
// module id = 1230
// module chunks = 12 14 15 57 62